import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import Button from "../Button";

const Base = styled.div<{ stretch?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: ${select.color(["grey", 0])};
  padding: ${select.space(3)};
  width: ${p => (p.stretch ? "100%" : "auto")};
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  stretch?: boolean;
  disabled?: boolean;
  onClick: () => void;
  text: string;
};

function UploadBox(
  { style, className, text, disabled, onClick, stretch }: Props,
  ref: any
) {
  return (
    <Base ref={ref} style={style} stretch={stretch} className={className}>
      <Button type="grey" text={text} disabled={disabled} onClick={onClick} />
    </Base>
  );
}

export default React.forwardRef(UploadBox);
